"use client";

import Image from "next/image";
import Link from "next/link";

const CategoryGrid = ({ categories }) => (
  <div className="container mx-auto py-5">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
      {categories.map((category) => (
        <Link key={category.slug} href={`/projects/${category.slug}`} passHref>
          <div className="group block relative overflow-hidden shadow-lg ">
            {/* Image Background */}
            <div className="relative w-full h-60">
              <Image
                src={category.image}
                alt={category.title}
                fill
                className="object-cover transform transition-transform duration-300 group-hover:scale-110"
              />
            </div>

            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-25 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            {/* Title Overlay on the Bottom */}
            <div className="absolute bottom-0 w-full bg-gradient2-to-t from-black2 to-transparent2 px-2">
              <h3 className="text-base font-semibold text-white text-left ml-3">
                {category.title}
              </h3>
            </div>
          </div>
        </Link>
      ))}
    </div>
  </div>
);

export default CategoryGrid;
